export default __webpack_public_path__ + "static/media/0x034b2090b579228482520c589dbd397c53fc51cc.dd2a2b9c.png";